import qrModalContext from "@contexts/qrModalContext";
import { useContext } from "react";

export default () => {
	const context = useContext(qrModalContext);

	return context;
};
